import { useParams } from 'react-router'
import { ApplicationInformation } from 'src/screens/shared/application/details/application-information/ApplicationInformation'

export const PfPgvApplicationInformationPage = () => {
  const { projectId } = useParams()
  const pf_pgv_id = parseInt(projectId as string)

  return <ApplicationInformation baseUrl="/pf-pgv" projectId={pf_pgv_id} />
}
